/**
 * Interface for the 'PaymentMethods' data
 */
export interface PaymentMethodsEntity {
  auction: string
  created: string
  display_name: string
  flat_fee: string | null
  guest_payment_method: boolean
  optional_fee: OptionalFeeEnum.Mandatory | OptionalFeeEnum.AllOptional | OptionalFeeEnum.DonationOptional
  payment_method: string
  payment_process: PaymentProcessEnum.Card | PaymentProcessEnum.Generic | PaymentProcessEnum.Stripe
  percentage_fee: string | null
  updated: string
  uuid: string
  volunteer_payment_method: boolean
  apply_fee_to_final_charge: boolean
}

export enum OptionalFeeEnum {
  Mandatory = 'mandatory',
  AllOptional = 'all_optional',
  DonationOptional = 'donation_optional',
}

export enum FeeTypeEnum {
  Percentage = 'percentage',
  Flat = 'flat',
  Both = 'both',
  None = 'none',
}

export enum PaymentProcessEnum {
  Generic = 'generic',
  Card = 'card',
  Stripe = 'stripe',
}

export enum PaymentMethodEnum {
  Stripe = 'stripe',
}
